import { render } from "./slidebar.html?vue&type=template&id=62eddb80&scoped=true&external"
import script from "./slidebar.js?vue&type=script&lang=js&external"
export * from "./slidebar.js?vue&type=script&lang=js&external"

import "./slidebar.scss?vue&type=style&index=0&id=62eddb80&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62eddb80"],['__file',"src/components/ui/slidebar/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62eddb80"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62eddb80', __exports__)) {
    api.reload('62eddb80', __exports__)
  }
  
  module.hot.accept("./slidebar.html?vue&type=template&id=62eddb80&scoped=true&external", () => {
    api.rerender('62eddb80', render)
  })

}


export default __exports__